import React, { useState, useContext, useEffect } from 'react'
import { Col, Row, Form, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMobileAlt, faTabletAlt, faGlobeAsia, faUserCircle, faWindowMaximize } from '@fortawesome/free-solid-svg-icons'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { updateUser, viewUser, addUserRole, removeUserRole } from "../Network/User"
import { useHistory, useParams } from 'react-router-dom'
import { Loading, HeaderTitle } from '../Library'
import { listCompany } from '../Network/Company'
import { listDepartment, addUserToDepartment, removeFromDepartment } from '../Network/Department'
import { listRole } from '../Network/Role'
import MultiSelect from "react-multi-select-component";
import "./Linkroom.css"
import { setDocumentTitle } from '../AppTitle'
import { RoleContext } from "../Role/RoleContext"
import axios from 'axios'
import { wtc5214,visitor8082 } from '../Network/Config'

function CreateUser(props) {
    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.user
    const notifyCx = useContext(NotifyContext);
    const history = useHistory();
    const { securityId } = useParams();

    const [isLoading, setLoading] = useState(false);
    const [loadingTitle, setLoadingTitle] = useState("Loading");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [timelimit, setTimelimit] = useState("99:99:99");
    const [type, setType] = useState("admin");
    const [isError, setError] = useState(false);


    const [role, setRole] = useState([])

    useEffect(() => {
        setDocumentTitle("Create Security")
        console.log('Token : ', props.token)
    }, [])


    const onSubmit = () =>{
        if( !firstName ){ 
            notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true);
            return;
        }
        setLoadingTitle(lang.updating)
        setLoading(true);
        addUsers(firstName, lastName, email, phone, timelimit, type);
    }
    
    const addUsers = async (firstname, lastname, email, phone, timeimit, type) =>{
        const formDataUpdate = new FormData();
        formDataUpdate.append('firstname', firstname);
        formDataUpdate.append('lastname', lastname);
        formDataUpdate.append('email', email);
        formDataUpdate.append('phone', phone);
        formDataUpdate.append('timeimit', timeimit);
        formDataUpdate.append('type', type);
        const headers = {
            'Authorization': props.token,
        };
        const responseData = await axios.post('https://visitor-api.lifelink.co.th:10443/linkroom/api/admin/v1/adduser', formDataUpdate,{ headers });
        setLoading(false)
        history.push("/users")
    }

    return (
        <>
        { isLoading ? <Loading title={loadingTitle}/>: null }
        <div id="create-user">
            <HeaderTitle title={'เพิ่มผู้ใช้งาน'} isShowBack backTo="/users"/>
            <Row style={{width: "100%"}}>
                <Col className="content-container" md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault();
                        onSubmit();
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{'ชื่อ'}</Form.Label>
                            <Form.Control
                            placeholder="ชื่อ"
                            value={firstName}
                            isInvalid={isError && !firstName}
                            onChange={(e)=>setFirstName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{'นามสกุล'}</Form.Label>
                            <Form.Control
                            placeholder="นามสกุล"
                            value={lastName}
                            isInvalid={isError && !lastName}
                            onChange={(e)=>setLastName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{'อีเมล'}</Form.Label>
                            <Form.Control
                            placeholder="อีเมล"
                            value={email}
                            isInvalid={isError && !email}
                            onChange={(e)=>setEmail(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{'เบอร์โทรศัพท์'}</Form.Label>
                            <Form.Control
                            placeholder="เบอร์โทรศัพท์"
                            value={phone}
                            isInvalid={isError && !phone}
                            onChange={(e)=>setPhone(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{'ประเภท'}</Form.Label>
                            <Form.Control as="select" value={type} onChange={(e)=>setType(e.target.value)}>
                                <option value={'admin'}>{'Admin'}</option>
                                <option value={'user'}>{'User'}</option> 
                            </Form.Control>
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            <Button type="submit" style={{marginTop: 30}}>{'บันทึกรายชื่อใหม่'}</Button>
                        </Form.Group>
                        
                    </Form>
                </Col>
            </Row>
        </div>
        </>
    )
}

function AccessItem(props){
    return(
        <div className="access-item"
        onClick={props.onClick}
        role="button"
        tabIndex="0"
        aria-pressed="false"
        onKeyDown={(e)=>{
            if(e.key === "Enter"){
                props.onClick()
            }
        }}
        style={{
            borderColor: props.isError ? "red": "lightgray",
            color: props.isSelected ? "white" : "black",
            backgroundColor: props.isSelected ? "#0275d8": "white"
        }}
        >
            <div>
                <div className="icon">
                    <FontAwesomeIcon icon={props.icon}/>
                </div>
                <div className="title">{props.title}</div>
            </div>
        </div>
    )
}

function RoleList(){
    return(
        <div>
            <b className="title-role">Role</b>
            <div>
                <div className="role-item">
                    <div>System admin</div>
                    <div className="desc">Description here</div>
                </div>
            </div>
        </div>
    )
}

export default CreateUser
